var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import _ from 'lodash';
import BusinessGoodsPriceService from '../../../api/BusinessGoodsPriceService';
import VueDialog from "../../../interface/IVueDialog";
import AddGoodTable from './AddGoodTable.vue';
var EActiveType;
(function (EActiveType) {
    EActiveType["UNSELECTED"] = "0";
    EActiveType["SELECTED"] = "1";
})(EActiveType || (EActiveType = {}));
var AddDialog = (function (_super) {
    __extends(AddDialog, _super);
    function AddDialog() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.activeName = '0';
        _this.periodicList = [];
        _this.total = 0;
        _this.unSelectList = [];
        _this.selectedList = [];
        _this.type = '';
        _this.canFreshTable = true;
        _this.loading = false;
        _this.categoryData = [];
        _this.formData = {
            goods_type_id: [],
            keyword: ''
        };
        return _this;
    }
    AddDialog.prototype.created = function () {
        this.service = BusinessGoodsPriceService.getInstance();
        this.selectedList = [];
        this.getCategory();
        this.getGoodList();
    };
    AddDialog.prototype.getCategory = function () {
        var _this = this;
        this.service.getAddCategory().then(function (res) {
            if (res.data.success) {
                _this.categoryData = res.data.data;
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    AddDialog.prototype.getIds = function (arr, key) {
        if (!this.purchasers)
            return null;
        return _.reduce(arr, function (ori, newItem) {
            return ori += ori ? (',' + newItem[key]) : newItem[key];
        }, '');
    };
    AddDialog.prototype.getGoodList = function (pager) {
        var _this = this;
        if (pager === void 0) { pager = { page: 1, start: 0, limit: 20 }; }
        this.loading = true;
        var ids;
        var goodsType = 'goods_format_id';
        ids = (this.addedDatas || []).map(function (item) {
            return item[goodsType];
        });
        if (this.type == 'goods') {
            this.service.getGoodslist(Object.assign({}, {
                goods_type: (this.formData.goods_type_id || []).length ? this.formData.goods_type_id.slice().reverse()[0] : '',
                keyword: this.formData.keyword,
                selected_goods_format_ids: (ids || []).join(',')
            }, pager)).then(function (res) {
                if (res.data.success) {
                    _this.unSelectList = res.data.data;
                    _this.total = res.data.total;
                    _this.setSelected(true);
                }
                else {
                    _this.$message.error(res.data.msg);
                }
                _this.loading = false;
            }, function (err) {
                _this.$message.error(err.message);
                _this.loading = false;
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                _this.loading = false;
            });
        }
        else {
            this.service.getAddGoodslist(Object.assign({}, {
                goods_type: (this.formData.goods_type_id || []).length ? this.formData.goods_type_id.slice().reverse()[0] : '',
                keyword: this.formData.keyword,
                selected_goods_format_ids: (ids || []).join(',')
            }, pager)).then(function (res) {
                if (res.data.success) {
                    _this.unSelectList = res.data.data;
                    _this.total = res.data.total;
                    _this.setSelected(true);
                }
                else {
                    _this.$message.error(res.data.msg);
                }
                _this.loading = false;
            }, function (err) {
                _this.$message.error(err.message);
                _this.loading = false;
            }).catch(function (err) {
                _this.$message.error(err.msg || err.message);
                _this.loading = false;
            });
        }
    };
    AddDialog.prototype.selectChange = function (rows, currentRow, isSelectAll) {
        var _this = this;
        if (isSelectAll === void 0) { isSelectAll = false; }
        if (!this.canFreshTable)
            return;
        this.canFreshTable = false;
        var currentSelectRows = _.filter(rows, function (row) { return !!row; });
        var goodsType = 'goods_format_id';
        this.selectedList = _.uniqBy(this.selectedList.concat(currentSelectRows), goodsType);
        var isUnselectAll = !(currentSelectRows || []).length && !currentRow && isSelectAll;
        if (currentRow && !_.find(currentSelectRows, function (good) { return good[goodsType] === currentRow[goodsType]; })) {
            _.remove(this.selectedList, function (good) { return good[goodsType] === currentRow[goodsType]; });
        }
        else if (isUnselectAll && this.activeName === EActiveType.SELECTED) {
            this.selectedList = [];
        }
        else if (isUnselectAll) {
            this.unSelectList.forEach(function (good) {
                _.remove(_this.selectedList, function (item) { return item[goodsType] === good[goodsType]; });
            });
        }
        this.setSelected(this.activeName === EActiveType.SELECTED);
        setTimeout(function () {
            _this.canFreshTable = true;
        });
    };
    AddDialog.prototype.setSelected = function (isUnSelFresh) {
        var _this = this;
        if (isUnSelFresh === void 0) { isUnSelFresh = false; }
        var gridTable = this.$refs.grid.$refs.table;
        if (isUnSelFresh) {
            gridTable.clearSelection();
        }
        if (!(this.selectedList || []).length) {
            this.$refs.alreadyGrid.$refs.table.clearSelection();
        }
        else {
            this.selectedList.forEach(function (good, index) {
                _this.$nextTick(function () {
                    _this.$refs.alreadyGrid.$refs.table.toggleRowSelection(good, true);
                });
                if (isUnSelFresh) {
                    var goodsType_1 = 'goods_format_id';
                    var item_1 = _.find(_this.unSelectList, function (current) { return current[goodsType_1] === good[goodsType_1]; });
                    _this.$nextTick(function () {
                        gridTable.toggleRowSelection(item_1, true);
                    });
                }
            });
        }
    };
    AddDialog.prototype.search = function () {
        this.getGoodList();
    };
    AddDialog.prototype.close = function () {
        this.$closeDialog();
    };
    AddDialog.prototype.submitData = function () {
        var goodsType = 'goods_format_id';
        var data = _.uniqBy(this.selectedList.concat(this.addedDatas), goodsType);
        if ((data || []).length >= 50000) {
            this.$message.warning('货品记录不超过5万条');
            return;
        }
        this.$emit("submit", data);
        this.close();
    };
    AddDialog.prototype.pageChange = function (pager) {
        this.getGoodList(pager);
        this.$refs.grid.$refs.table.bodyWrapper.scrollTop = 0;
    };
    AddDialog.prototype.normalizer = function (node) {
        return {
            id: node.goods_type_id,
            label: node.goods_type_name,
            children: node.children,
        };
    };
    AddDialog = __decorate([
        Component({
            components: {
                'add-good-table': AddGoodTable
            },
            computed: {
                isMultiple: function () {
                    return (_.uniqBy(this.purchasers, 'business_id') || []).length > 1;
                }
            }
        })
    ], AddDialog);
    return AddDialog;
}(VueDialog));
export default AddDialog;
